import { Typography } from "@mui/material"

export const NoteImageSize = () => {
  return (
    <Typography variant="subtitle2" gutterBottom>
    Nota: Solo se pueden subir imagenes menores de 2MB, 
    para comprimir la imagen le recomendamos utizilizar este sitio web <a target={"_blank"} href="https://squoosh.app/">https://squoosh.app/</a>
    </Typography>
  )
}
